/**
 * components/feedback/PageLoader.jsx — Suspense fallback while a lazy page chunk loads.
 */
import React from 'react';

export function PageLoader() {
    return (
        <div style={{ minHeight: '40vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }} aria-busy="true">
            <style>{'@keyframes ra-spin{to{transform:rotate(360deg)}}'}</style>
            <div style={{ width: 32, height: 32, borderRadius: '50%', border: '3px solid #e2e8f0', borderTopColor: '#C9721C', animation: 'ra-spin 0.8s linear infinite' }} />
        </div>
    );
}
